import * as api from '../api';
import * as constants from "../actionTypes";


export const getSaveRequest = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getSaveRequest.REQUEST
        })
        const { data } = await api.getSaveRequest(props);
        dispatch ({
            type: constants.getSaveRequest.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getOtherRequest = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getOtherRequest.REQUEST
        })
        const { data } = await api.getOtherRequest(props);
        dispatch ({
            type: constants.getOtherRequest.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getAimag = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getAimag.REQUEST
        })
        const { data } = await api.getAimag();
        dispatch ({
            type: constants.getAimag.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getAimagWater = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getAimagWater.REQUEST
        })
        const { data } = await api.getAimagWater();
        dispatch ({
            type: constants.getAimagWater.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const getRequest = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getRequest.REQUEST
        })
        const { data } = await api.getRequest(props);
        dispatch ({
            type: constants.getRequest.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const getRequestWater = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getRequestWater.REQUEST
        })
        const { data } = await api.getRequestWater(props);
        dispatch ({
            type: constants.getRequestWater.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
}
}

export const downloadFile = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.downloadFile.REQUEST
        })
        const { data } = await api.downloadFile(props);
        dispatch ({
            type: constants.downloadFile.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}


export const getRate = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getRate.REQUEST
        })
        const { data } = await api.getRate(props);
        dispatch ({
            type: constants.getRate.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getUploadFile = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getUploadFile.REQUEST
        })
        const { data } = await api.getUploadFile(props);
        dispatch ({
            type: constants.getUploadFile.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getDefinition = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getDefinition.REQUEST
        })
        const { data } = await api.getDefinition(props);
        dispatch ({
            type: constants.getDefinition.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const getDefinitions = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getDefinitions.REQUEST
        })
        const { data } = await api.getDefinitions(props);
        dispatch ({
            type: constants.getDefinitions.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const getRequests = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getRequests.REQUEST
        })
        const { data } = await api.getRequests(props);
        dispatch ({
            type: constants.getRequests.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const sendToMail = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.sendToMail.REQUEST
        })
        const { data } = await api.sendToMail(props);
        dispatch ({
            type: constants.sendToMail.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const downToMail = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.downToMail.REQUEST
        })
        const { data } = await api.downToMail(props);
        dispatch ({
            type: constants.downToMail.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const getSettings = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getSettings.REQUEST
        })
        const { data } = await api.getSettings(props);
        dispatch ({
            type: constants.getSettings.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const updateSettings = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.updateSettings.REQUEST
        })
        const { data } = await api.updateSettings(props);
        dispatch ({
            type: constants.updateSettings.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getDashboardSingle = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getDashboardSingle.REQUEST
        })
        const { data } = await api.getDashboardSingle(props);
        dispatch ({
            type: constants.getDashboardSingle.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}

export const getDashboardMulti = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getDashboardMulti.REQUEST
        })
        const { data } = await api.getDashboardMulti(props);
        dispatch ({
            type: constants.getDashboardMulti.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const checkDateData = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.checkDateData.REQUEST
        })
        const { data } = await api.checkDateData(props);
        dispatch ({
            type: constants.checkDateData.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}
export const getConfirmationPage = (props)=> async (dispatch)=> {
    try {
        dispatch({
            type: constants.getConfirmationPage.REQUEST
        })
        const { data } = await api.getConfirmationPage(props);
        dispatch ({
            type: constants.getConfirmationPage.RESPONSE,
            payload:data 
        });
        return data
    } catch (error) {
        console.log(error.message)
    }
}







